
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	@Component({
		name: 'bmgl'
	})
	export default class bmgl extends Vue {
		messageTypeList: Array < any > = [];
		messageDate = {
			id:'',
			typeName:'',
			orderNum:0
		};
		currentNo: number = 1;
		pageSize: number = 10;
		pageTotal: number = 0;
		showbmxxVisible: boolean = false;

		searchForm= {
			typeName: ''
		}
		loading: boolean = false;
		dataListSelections=[];
		sjbm=[]
		selectBm=''
		dataRule={
			typeName: [
				{required: true, message: '类型名称不能为空', trigger: 'blur'}
			],
			orderNum: [
				{required: true, message: '排序号不能为空', trigger: 'blur'}
			]
		}
		created() {
			this.searchData();
		}

		handleSizeChange(val: number) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val: number) {
			this.currentNo = val;
			this.searchData();
		}
		searchData() {
			this.loading = true;
			this.$request({
					url: '/bjba/message/type/page',
					method: 'get',
					params: {
						page: this.currentNo,
						pageSize: this.pageSize,
						typeName: this.searchForm.typeName
					}
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.messageTypeList = data.data.content;
						this.pageTotal = data.data.totalElements
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(msg)
				});
		}
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}
		showMessageType(val: any) {
			// this.messageDate = { ...val };
			if(val) {
				this.messageDate.id = val.id;
				this.messageDate.typeName = val.typeName;
				this.messageDate.orderNum = val.orderNum;
			}else {
				this.messageDate.id = '';
				this.messageDate.typeName = '';
				this.messageDate.orderNum = 0;
			}
			this.showbmxxVisible = true;
		}
		savebmxx(bmxx: any) {
			this.$refs['form'].validate((valid) => {
			if(valid) {
				this.$request({
					url: '/bjba/message/type/save',
					method: 'post',
					data: this.messageDate
				})
						.then(response => {
							console.log(response);
							let data = response.data;
							if (data.code == 200) {
								this.$message.success(data.message)
								this.showbmxxVisible = false;
								this.searchData();
							} else {
								this.$message.error(data.message)
							}

						})
						.catch(error => {
							console.log(error)
							this.$message.error(msg)
						});
			}
			})


		}
		deleteHandle (id) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			if(!ids || ids.length==0) return
			this.$confirm(`确定进行[删除]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/message/type/delete`,
					method: 'post',
					data: ids
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.searchData()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}
	}
